// src/components/Sidebar.js
import React, { useEffect, useState } from "react";
import logo from "../../assets/images/Logo-Usakti-Putih.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useAuth } from "../../Context/AuthContext";

const Sidebar = ({ toggled }) => {
  const { logout } = useAuth();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(null); // Menyimpan menu yang aktif
  const [userRoles, setUserRoles] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const userRole = Cookies.get("userRoles");
        setUserRoles(userRole);
      } catch (error) {
        logout();
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const toggleMenu = (menuName) => {
    setActiveMenu(activeMenu === menuName ? null : menuName); // Aktif/nonaktif menu
  };

  return (
    loading == false && (
      <div className={`sidenav ${toggled ? "toggled" : ""}`}>
        <nav className="sb-sidenav sb-sidenav-dark">
          <div
            className="sb-sidenav-header d-flex justify-content-center"
            style={{ alignItems: "center" }}
          >
            <img src={logo} alt="logo" height={70} />
          </div>

          <div className="sb-sidenav-menu mt-4">
            <ul className="nav flex-column">
              <li className="nav-item mb-2">
                <div className="sidenav-menu-heading">AKADEMIK</div>
              </li>
              {(userRoles == "SUPER ADMIN" ||
                userRoles == "KPM" ||
                userRoles == "SPM") && (
                <>
                  <li className="nav-item mb-2">
                    <NavLink
                      to="/akademik/courses"
                      style={{ color: "rgba(255, 255, 255, 0.55)" }}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center gap-2 ${
                          isActive ? "active" : ""
                        }`
                      }
                    >
                      <i className="fas fa-book-open"></i> Daftar Modul
                    </NavLink>
                  </li>
                  <li className="nav-item mb-2">
                    <NavLink
                      to="/akademik/course-lecturers"
                      style={{ color: "rgba(255, 255, 255, 0.55)" }}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center gap-2 ${
                          isActive ? "active" : ""
                        }`
                      }
                    >
                      <i className="fas fa-scroll"></i> Reg. Modul Dosen
                    </NavLink>
                  </li>
                  <li className="nav-item mb-2">
                    <NavLink
                      to="/akademik/course-students"
                      style={{ color: "rgba(255, 255, 255, 0.55)" }}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center gap-2 ${
                          isActive ? "active" : ""
                        }`
                      }
                    >
                      <i className="fas fa-file-circle-check"></i> KRS
                    </NavLink>
                  </li>
                  <li className="nav-item mb-2">
                    <NavLink
                      end={true}
                      to="/akademik/course-sessions"
                      style={{ color: "rgba(255, 255, 255, 0.55)" }}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center gap-2 ${
                          isActive ? "active" : ""
                        }`
                      }
                    >
                      <i className="fas fa-bookmark"></i> Man Jadwal Kelas
                    </NavLink>
                  </li>
                </>
              )}

              {userRoles === "MAHASISWA" && (
                <li className="nav-item mb-2">
                  <NavLink
                    to="/akademik/course-attendance/logbook"
                    style={{ color: "rgba(255, 255, 255, 0.55)" }}
                    className={({ isActive }) =>
                      `nav-link d-flex align-items-center gap-2 ${
                        isActive ? "active" : ""
                      }`
                    }
                  >
                    <i className="fas fa-book-open"></i> Daftar Logbook
                  </NavLink>
                </li>
              )}

              <li className="nav-item mb-2">
                <NavLink
                  to="/akademik/course-sessions/all"
                  style={{ color: "rgba(255, 255, 255, 0.55)" }}
                  className={({ isActive }) =>
                    `nav-link d-flex align-items-center gap-2 ${
                      isActive ? "active" : ""
                    }`
                  }
                >
                  <i className="fas fa-bookmark"></i> Jadwal Kelas
                </NavLink>
              </li>

              {(userRoles == "SUPER ADMIN" ||
                userRoles == "KPM" ||
                userRoles == "SPM") && (
                <>
                  <li className="nav-item mb-2">
                    <div className="sidenav-menu-heading">PENGATURAN</div>
                  </li>
                  <li
                    className={`nav-item mb-2 ${
                      activeMenu === "manAkademik" ? "active" : ""
                    }`}
                  >
                    <div
                      onClick={() => toggleMenu("manAkademik")}
                      className="nav-link d-flex align-items-center justify-content-between gap-2"
                      style={{
                        color: "rgba(255, 255, 255, 0.55)",
                        cursor: "pointer",
                      }}
                    >
                      <span className="d-flex align-items-center gap-2">
                        <i className="fas fa-users"></i> Man Akademik
                      </span>
                      <i
                        className={`fas ${
                          activeMenu === "manAkademik"
                            ? "fa-angle-down"
                            : "fa-angle-right"
                        }`}
                      ></i>
                    </div>
                    <ul
                      className={`submenu ${
                        activeMenu === "manAkademik" ? "active" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          style={{ color: "rgba(255, 255, 255, 0.55)" }}
                          to="/period-management"
                          className={({ isActive }) =>
                            `submenu-item ${isActive ? "active" : ""}`
                          }
                        >
                          <i className="far fa-clock"></i> Man. Periode Akademik
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          style={{ color: "rgba(255, 255, 255, 0.55)" }}
                          to="/classroom-management"
                          className={({ isActive }) =>
                            `submenu-item ${isActive ? "active" : ""}`
                          }
                        >
                          <i className="fas fa-calendar"></i> Man. Ruang Kelas
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          style={{ color: "rgba(255, 255, 255, 0.55)" }}
                          to="/group-courses"
                          className={({ isActive }) =>
                            `submenu-item ${isActive ? "active" : ""}`
                          }
                        >
                          <i className="fa fa-book-bookmark"></i> Man. Kelompok
                          Modul
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li
                    className={`nav-item mb-2 ${
                      activeMenu === "pengguna" ? "active" : ""
                    }`}
                  >
                    <div
                      onClick={() => toggleMenu("pengguna")}
                      className="nav-link d-flex align-items-center justify-content-between gap-2"
                      style={{
                        color: "rgba(255, 255, 255, 0.55)",
                        cursor: "pointer",
                      }}
                    >
                      <span className="d-flex align-items-center gap-2">
                        <i className="fas fa-users"></i> Pengguna
                      </span>
                      <i
                        className={`fas ${
                          activeMenu === "pengguna"
                            ? "fa-angle-down"
                            : "fa-angle-right"
                        }`}
                      ></i>
                    </div>
                    <ul
                      className={`submenu ${
                        activeMenu === "pengguna" ? "active" : ""
                      }`}
                    >
                      <li>
                        <NavLink
                          style={{ color: "rgba(255, 255, 255, 0.55)" }}
                          to="/user-management"
                          className={({ isActive }) =>
                            `submenu-item ${isActive ? "active" : ""}`
                          }
                        >
                          <i className="fas fa-user"></i> Man. Pengguna
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </>
              )}
              {userRoles == "SUPER ADMIN" && (
                <>
                  <li className="nav-item mb-2">
                    <div className="sidenav-menu-heading">BACKUP / RESTORE</div>
                  </li>
                  <li className="nav-item mb-2">
                    <NavLink
                      end={true}
                      to="/backup-restore"
                      style={{ color: "rgba(255, 255, 255, 0.55)" }}
                      className={({ isActive }) =>
                        `nav-link d-flex align-items-center gap-2 ${
                          isActive ? "active" : ""
                        }`
                      }
                    >
                      <i className="fas fa-database"></i> Backup / Restore
                    </NavLink>
                  </li>
                </>
              )}
            </ul>
          </div>

          <div className="sb-sidenav-footer">
            <p>&copy; 2024 Universitas Trisakti</p>
          </div>
        </nav>
      </div>
    )
  );
};

export default Sidebar;
